export enum CustomEventName {
  ClickShareBlog = 'click_share_blog',
  ViewFullPage = 'view_full_page',
  CustomButtonClick = 'custom_button_click',
  ClickLeadsButton = 'click_leads_button',
  FormSubmission = 'form_submission',
  ContactFormSubmission = 'contact_form_submission',
}
